angular.
module("dx.webapp.api").
factory("dxApiLegacyGrades", function apiLegacyGradesService(
	$http
) {
	"use strict";

	function gradesPost(grade) {
		// Score is not nullable server side
		//
		// So we need to help the server to determine if the score is actually set
		// to a value by the user
		grade.isScoreSet = grade.score !== null && typeof grade.score !== "undefined";

		return $http.post("/grade/save/", grade);
	}

	return {
		post: gradesPost,
	};
});
